export default __webpack_public_path__ + "static/success-1d197d663ed6b9830a5e50b5cefae206.svg";